'use client';

import * as React from 'react';
import { SpecialErrorType, useSpecialError } from '@/shared/components/special-error';
import { usePublicProfileDataQuery } from '../../hooks/use-public-profile-data-query';
import { Cover } from '../cover';
import { SkeletonProfile } from '../skeleton-profile';
import { UserInfo } from '../user-info';
import * as Styled from './profile-page.styled';
export const PublicProfilePage = React.memo(function PublicProfilePage({
  children
}: React.PropsWithChildren) {
  const {
    data,
    isLoading,
    isError,
    error
  } = usePublicProfileDataQuery();
  const setSpecialError = useSpecialError();
  React.useEffect(() => {
    if (isError && error) {
      setSpecialError(new Error(SpecialErrorType.NotFound));
    }
  }, [error, isError, setSpecialError]);
  if (!data || isLoading) {
    // In case of an error, it will be thrown to `ErrorBoundary`
    return <SkeletonProfile />;
  }
  return <>
      <Cover />
      <Styled.UserInfo>
        <UserInfo plariumId={data.id} username={data.name} avatar={data.avatar} />
      </Styled.UserInfo>
      <Styled.Main $hasTabs={false}>{children}</Styled.Main>
    </>;
});